export default __webpack_public_path__ + "static/media/smit.49f8e903.jpeg";